import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, CheckCircleIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  index: number;
}
function FAQItem({
  question,
  answer,
  index
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="border border-gray-700 rounded-lg overflow-hidden bg-gray-900/50" data-id="element-31">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-800/50 transition-colors" data-id="element-32">
        <span className="font-semibold text-lg pr-4" data-id="element-33">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-34">
          <ChevronDownIcon className="w-6 h-6 text-amber-500 flex-shrink-0" data-id="element-35" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-36">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-37">
            <div className="px-6 pb-6 text-gray-300 leading-relaxed flex gap-3" data-id="element-38">
              <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-39" />
              <p data-id="element-40">{answer}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQSection() {
  const faqs = [{
    question: '❓ ¿Necesito hablar inglés perfecto?',
    answer: 'No. Te enseñamos a usar herramientas de IA para traducir y redactar con gramática perfecta. Tus clientes nunca sabrán que el inglés no es tu primer idioma.'
  }, {
    question: '❓ ¿Tengo que ser experto en tecnología?',
    answer: 'Si sabes usar WhatsApp y enviar un correo, puedes hacer esto. El sistema es "copiar y pegar".'
  }, {
    question: '❓ ¿Cuánto tiempo necesito al día?',
    answer: 'Puedes empezar con 30-60 minutos al día después de tu trabajo actual.'
  }];
  return <section className="py-20 px-4 bg-gradient-to-b from-black/40 to-transparent" data-id="element-41">
      <div className="max-w-4xl mx-auto" data-id="element-42">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-43">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} index={index} data-id="element-45" />)}
        </div>
      </div>
    </section>;
}